import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Footer from './components/Footer';
import Nav from './Header/Nav';
import node from '../assets/images/node.jpg';
import nodesvg from '../assets/images/nodejs.svg';
import training5 from '../assets/images/training5.jpg';
import DevelopRequest from './components/DevelopRequest';
import Subscribe from './components/Subscribe';


class FullStackJs extends Component{
    render(){
        return(
            <div id="App">
            <SideBar />
                <Nav />
            <header className="showcase" style={{height:'80vh', marginTop:'5vh', backgroundImage: `url(${training5})`}}>
			<div className="showcase-content">
                <div></div>
                <div>
				<h1>Be in <span className="alt-col" style={{color:'rgba(226, 155, 24, 0.945)'}}> Demand.</span></h1>
                <p>"The Web as I envisaged it, we have not seen it yet. The future is still so much bigger than the past."</p>
                <p>
                &mdash; Tim Berners-Lee, Inventor of the World Wide Web.
                </p>
                </div>
			</div>
		</header>
        <div className="about">
            <div style={{backgroundImage: `url(${node})`, backgroundClip:'border-box', backgroundPosition:'center', backgroundSize:'cover'}}></div>

            <div>
            <h3 className="path">Full-stack JavaScript Bundle</h3>
            <img src={nodesvg} alt="Full-stack JavaScript training in abuja" />
            <p> 
               Being a full-stack JavaScript developer means that you know how to combine both front-end and back-end techniques to build an interactive, database-driven
               website using JavaScript as the core programming language.
            </p>
            <p> 
            If you're looking to begin your full-stack developer's journey, this is a great way to get you there.
            </p>

            <h3>courses</h3>
            <p>
                HTML5, CSS3, Bootstrap 4, ES6, React, Node, MysQL.
            </p>

            <h3>call anytime</h3>
            <p>07063509602, 07084894979</p>
            <p>info@codeflarelimited.com</p>

            <h3>visit us</h3>
            <p>Suite C3-19 Central Market Plaza, Beside Sledge Resort, Off Byazhin Roundabout, Kubwa, Abuja.</p>
            </div>
        </div>
        <DevelopRequest />
        <Subscribe />
        <Footer />
            </div>
        )
    }
}

export default FullStackJs;